import forEach from '../../../../javascripts/dom/forEach';

const stories = document.querySelectorAll('[data-js-module="o-stories"]');

const init = async () => {
  const { default: Stories } = await import(/* webpackChunkName: "o-stories" */ './stories');
  forEach(stories, (index, element) => new Stories(element));
};

if (stories.length) init();
